import { congratulation } from '@assets/icons'
import Button from '@components/button'
import Svg from '@components/svg'
import React, { Fragment, useEffect, useState } from 'react'
import {
  ActionButton,
  ActionButtonContainer,
  Message,
  StyleRoomDetailMessage,
  StyleRoomDetailTitle,
  StyleSuccessAlertWrapper,
} from './style'
import { useModal } from '@context/ModalContext'
import Column from '@components/column'
import { Form, Formik } from 'formik'
import Fields from '@components/fields'
import { Match } from '@apis/index'
import { useNavigate } from 'react-router-dom'

const SuccessAlert = ({ data }: { data?: any }) => {
  const navigate = useNavigate()
  const { showModal, hideModal } = useModal()
  return (
    <Fragment>
      <StyleSuccessAlertWrapper>
        <Svg src={congratulation} />
        <Message>Match room successfully created now.</Message>

        <ActionButtonContainer style={{ display: 'flex', gap: '12px' }}>
          <ActionButton
            variant="addLater"
            onClick={() => {
              hideModal()
              navigate('/admin/game-management/match-rooms')
            }}
          >
            Add Later
          </ActionButton>
          <ActionButton
            onClick={() => {
              showModal(<ProvideRoomDetails data={data} />)
            }}
          >
            Add Room Details
          </ActionButton>
        </ActionButtonContainer>
      </StyleSuccessAlertWrapper>
    </Fragment>
  )
}

export default SuccessAlert

export const ProvideRoomDetails = ({ data }: { data?: any }) => {
  console.log({ data })
  const { hideModal } = useModal()
  const navigate = useNavigate()
  const isDisabled =
    (!!data?.infos?.roomId && !!data?.infos?.password) ||
    data.status !== 'Not Started'
  const [initialValues, setInitialValues] = useState({
    roomId: '',
    password: '',
  })
  useEffect(() => {
    if (!!data.infos) {
      console.log('Setting values:', {
        roomId: data.infos.roomId,
        password: data.infos.password,
      })
      setInitialValues({
        roomId: data?.infos?.roomId,
        password: data?.infos?.password,
      })
    }
  }, [data])

  const handleAddRoom = async (values) => {
    try {
      const payload = {
        name: data.name || data.matchroomName,
        infos: {
          roomId: values.roomId,
          password: values.password,
        },
      }
      await Match.update({
        data: JSON.stringify(payload),
        id: data.id,
        state: 'matches',
      }).then(() => {
        hideModal()
        navigate('/admin/game-management/match-rooms')
      })
    } catch (error) {}
  }
  return (
    <Fragment>
      <Column>
        <StyleRoomDetailTitle>Provide Room Details</StyleRoomDetailTitle>
        <StyleRoomDetailMessage>
          NOTE: Room ID & Password will be shared 10min before the game
        </StyleRoomDetailMessage>
        <Formik
          initialValues={initialValues}
          onSubmit={handleAddRoom}
          enableReinitialize
        >
          <Form>
            <Column>
              <Fields.Input
                // styleInput={isDisabled ? disabledInput : ''}
                label="Room ID"
                placeholder="Enter room ID"
                name="roomId"
              />
              <Fields.Input
                // styleInput={isDisabled ? disabledInput : ''}
                label="Password"
                placeholder="Enter room Password"
                name="password"
              />
              <Button
                title="Submit"
                type="submit"
                height={50}
                width={100}
                // styleButton={isDisabled ? disabledInput : ''}
              />
            </Column>
          </Form>
        </Formik>
      </Column>
    </Fragment>
  )
}

const disabledInput = `
  background-color: #f0f0f0;
  color: #888;
  pointer-events:none
  `
